export default __webpack_public_path__ + "static/powerapps-c650293e6ba3b81f881fdf4327895219.png";